import { Component } from "@angular/core";
import { Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataSharingService } from "../../services/dataSharing/data-sharing.service";
import Swal from "sweetalert2";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { CommonService } from "../../services/common/common.service";
import {
  FormArray,
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class ChangePasswordComponent {
  userType: any;
  id: any;
  receivedData: any;

  changePasswordForm: any;
  otpDiv = false;
  sendotpDiv = true;
  verifyotpDiv = false;
  submitted = false;
  postObj: any;
  // changePasswordForm: FormGroup | undefined;
  constructor(
    private AuthenticationService: AuthenticationService,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private dataService: DataSharingService,
    public CommonService: CommonService
  ) {}
  ngOnInit() {
    this.userType = this.dataService.getUserType();
    this.id = this.dataService.getId();
    // this.userType = "customer";
    // this.id = 1;
    this.changePasswordForm = this.fb.group(
      {
        changePassword: ["", [Validators.required]],
        confirmPassword: ["", [Validators.required]],
        userType: [this.userType, [Validators.required]],
        id: [this.id, [Validators.required]],
      },
      {}
    );

    // console.log("this.userType---", this.userType);
    // console.log("this.id---", this.id);
    if (this.userType == undefined) {
      alert("undefinded");
      this.router.navigate(["/login"]);
    }
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  onCancel() {
    Swal.fire({
      title: "Are you sure?",
      text: "You don't want to change your password.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(["/login"]);
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.changePasswordForm.valid) {
      const changePassword = this.changePasswordForm.value.changePassword;
      const confirmPassword = this.changePasswordForm.value.confirmPassword;
      if (changePassword !== confirmPassword) {
        this.submitted = false;
        Swal.fire({
          title: "Warning!",
          text: "Change password and confirm password is missmatch.",
          icon: "warning",
          // timerProgressBar: true, // Display a progress bar as the timer counts down
          // showConfirmButton: false, // Hide the "OK" button
        });
        // return false;
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitted = true;

            this.postObj = {
              userType: this.changePasswordForm.value.userType,
              id: this.changePasswordForm.value.id,
              changePassword: this.changePasswordForm.value.changePassword,
              confirmPassword: this.changePasswordForm.value.confirmPassword,
            };

            // console.log("form data", this.postObj);
            this.AuthenticationService.changePassord(this.postObj).subscribe(
              (response: any) => {
                // console.log("response --- " + response);
                if (response.code == 1) {
                  Swal.fire({
                    title: "success!",
                    text: response.message,
                    icon: "success",
                    timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
                    // timerProgressBar: true, // Display a progress bar as the timer counts down
                    // showConfirmButton: false, // Hide the "OK" button
                  });

                  this.router.navigate(["/login"]);
                  // localStorage.setItem("user_id", response.user_id);
                  // localStorage.setItem("name", response.name);
                  // localStorage.setItem("email", response.email);
                  // localStorage.setItem("token", response.token);
                  // localStorage.setItem("userType", response.userType);
                  // localStorage.setItem("customerId", response.customerId);
                  // this.router.navigate(["/dash"]);
                } else {
                  Swal.fire({
                    title: "Warning!",
                    text: response.message,
                    icon: "warning",
                    timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
                    // timerProgressBar: true, // Display a progress bar as the timer counts down
                    // showConfirmButton: false, // Hide the "OK" button
                  });
                }
              }
            );
          }
        });
      }
    } else {
    }
  }
}
